import React, {useState} from "react"
import {Form, Input, message, Modal, Select, Spin, Tag} from "antd"
import {getMemberClubLevel, setDiscount} from "../../../../../api/clubMemberList"
import {useClubMemberContext} from "../../../store/useClubMemberContext"

const MemberEditLevel = ({memberId}) => {

    const [isShow, setIsShow] = useState(false)
    const [isLoading, setIsLoading] = useState(false)
    const [levelList, setLevelList] = useState([])
    const [form] = Form.useForm()

    const {fetchClubMemberList} = useClubMemberContext()

    const fetchMemberClubLevel = async () => {
        setIsLoading(true)
        await getMemberClubLevel(memberId).then(res => {
            if (res.status === 1) {
                const options = res.data.levelList.map(item => {
                    return {
                        label: <SelectLevelLabel discount={item.discount} name={item.name}/>,
                        value: item.id
                    }
                })
                const currentLevel = res.data.levelList.find(item => item.id === res.data.memberInLevelId)
                form.setFieldValue('level', currentLevel ? currentLevel.name : '暂无等级')
                setLevelList(options)
                return
            }
            message.error(`获取会员等级失败：${res.detail}`)
        }).catch(err => {
            console.log(err)
            message.error(`获取会员等级失败：${err.message}`)
        }).finally(() => {
            setIsLoading(false)
        })
    }

    const fetchSetDiscount = async (levelId) => {
        setIsLoading(true)
        const clubId = sessionStorage.getItem('clubId')
        await setDiscount(memberId, levelId, clubId).then(res => {
            if (res.status === 1) {
                message.success('修改成功')
                setIsShow(false)
                form.resetFields()
                return
            }
            message.error(`修改失败：${res.detail}`)
        }).catch(err => {
            message.error(`修改失败：${err.message}`)
        }).finally(() => {
            setIsLoading(false)
            fetchClubMemberList()
        })
    }

    const handleOnClick = async () => {
        setIsShow(true)
        await fetchMemberClubLevel()
    }

    const handleOnOk = async () => {
        await fetchSetDiscount(form.getFieldValue('newLevel'))
    }

    const handleCancel = () => {
        setIsShow(false)
        form.resetFields()
    }
    const items = [
        {
            label: '当前等级',
            name: 'level',
            children: (<Input disabled/>),
            rules: []
        },
        {
            label: '修改等级',
            name: 'newLevel',
            children: (
                <Select
                    style={{width: '100%'}}
                    placeholder={"请选择等级"}
                    options={levelList}
                >
                </Select>
            ),
            rules: [
                {required: true, message: '请输入等级'}
            ]
        },
    ]

    return (
        <div>
            <div onClick={handleOnClick}>修改等级</div>
            <Modal
                open={isShow}
                onCancel={handleCancel}
                onOk={form.submit}
                confirmLoading={isLoading}
                destroyOnClose
            >
                <Spin spinning={isLoading}>
                    <Form
                        form={form}
                        style={{padding: "0 20px"}}
                        labelCol={{span: 6}}
                        wrapperCol={{span: 18}}
                        onFinish={handleOnOk}
                    >
                        {items.map(item => {
                            return (
                                <Form.Item
                                    label={item.label}
                                    name={item.name}
                                    rules={item.rules}
                                >
                                    {item.children}
                                </Form.Item>
                            )
                        })}
                    </Form>
                </Spin>
            </Modal>
        </div>
    )
}

const SelectLevelLabel = ({name, discount}) => {

    if (discount === 1) {
        discount="无折扣"
    }else if (discount === 0) {
        discount = "免费"
    }else {
        discount=((discount*10).toFixed(1))+"折"
    }

    return (
        <div style={{display:"flex",justifyContent:"space-between"}}>
            <div>{name}</div>
            <div>
                <Tag color={"gold"}>{discount}</Tag>
            </div>
        </div>
    )

}

export default MemberEditLevel


// WEBPACK FOOTER //
// ./src/containers/ClubMemberList/component/ClubMemberEdit/component/ClubMemberEditLevel.js